define('MiniCartBuyButton',[
    "jquery",
    "eventManager",
    "SageDotCom/DataLayer/tealium"
], function ($, eventManager, tealium) {

    function MiniCartBuyButton() {

        eventManager.subscribe("Sage:AddProductEvent", triggerAddToCartTealiumEvent);
        eventManager.subscribe("Sage:RemoveProductEvent", triggerRemoveCartTealiumEvent);
    }

    function getEventData(product, isAdd) {
        var eventData = {
            "enh_action": isAdd ? "add" : "remove",
            "event_name": isAdd ? "remove" : "remove to cart",
            "event_non-int": "0",
            "event_category": "ecommerce",
            "event_action": "add to cart",
            "event_label": product.productLabel,
            "event_name_level_1": '',
            "event_name_level_2": product.parentSku,
            "event_name_level_3": product.productPrice,
            "event_name_level_4": product.productSku,
            "product_id": [product.productSku],
            "product_name": [product.productLabel],
            "product_category": [product.parentSku],
            "product_quantity": (typeof product.quantity == "function") ? product.quantity() : product.quantity, 
            "product_price": product.productPrice,
            "product_discount": ["0"],
            "product_brands": ["Sage"],
            //"product_payment_cadence": [$container.data("cadence")],
            //"product_subscription_type": [$container.data("subtype").toString()],
            //"product_subscription_length": [$container.data("sublength").toString()],
            //"product_number_of_users": [$container.data("users").toString()],
            "product_number_of_companies": ["1"],
            "product_number_of_employees": ["1"]
        };

        return eventData;
    }

    function triggerRemoveCartTealiumEvent(product) {
        if (product === undefined) return;
        var data = getEventData(product, false);
        tealium.event(data);
    }

    function triggerAddToCartTealiumEvent(product) {
        if (product === undefined) return;
        var data = getEventData(product, true);
        tealium.event(data);
    }

    return new MiniCartBuyButton();
});
